import { render, staticRenderFns } from "./searchResult.vue?vue&type=template&id=4887ac84&scoped=true&"
import script from "./searchResult.vue?vue&type=script&lang=ts&"
export * from "./searchResult.vue?vue&type=script&lang=ts&"
import style0 from "./searchResult.vue?vue&type=style&index=0&id=4887ac84&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4887ac84",
  null
  
)

export default component.exports